var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { defaultProps } from './defaults';
import { DivTag, addComponentPrefix } from '../../Utils/AtomicTag';
import { OptionList } from './OptionList';
import { Option } from './Option';
import { convertChildrenToData } from './util';
var AutoComplete = /** @class */ (function (_super) {
    __extends(AutoComplete, _super);
    function AutoComplete(props) {
        var _this = _super.call(this, props) || this;
        _this.getMergeOptions = function (options, children) {
            var newOptions = options;
            if (newOptions === undefined) {
                newOptions = convertChildrenToData(children);
            }
            _this.setState({
                mergeOptions: newOptions,
            });
        };
        /** input 获得焦点 */
        _this.onFocus = function () {
            _this.setState({
                open: true,
            });
            _this.props.onFocus();
        };
        /** input 值发生变化 */
        _this.onChange = function (e) {
            !_this.props.value &&
                _this.setState({
                    value: e.target.value,
                });
            if (!_this.state.open)
                _this.setState({ open: true });
            _this.props.onChange(e.target.value, e);
            _this.props.onSearch(e.target.value);
        };
        /** input 失去焦点 */
        _this.onBlur = function (e) {
            _this.setState({ open: false });
            _this.props.onBlur();
        };
        /** 类目选择 */
        _this.selectOption = function (e, option) {
            _this.setState({
                value: option.value,
                open: false,
            });
            _this.props.onChange(option.value, e);
            _this.props.onSelect(option.value, option);
        };
        /** 设置 values 值 */
        _this.setValues = function () {
            return new Set([_this.props.value ? _this.props.value : _this.state.value]);
        };
        _this.inputClick = function (e) {
            if (!_this.state.open) {
                _this.setState({
                    open: true,
                });
            }
        };
        _this.state = {
            value: props.value ? props.value : '',
            open: false,
            mergeOptions: [],
            inputRef: React.createRef(),
        };
        return _this;
    }
    AutoComplete.prototype.componentWillReceiveProps = function (nextProps) {
        this.getMergeOptions(nextProps.options, nextProps.children);
        if (nextProps.value !== undefined) {
            this.setState({
                value: nextProps.value,
            });
        }
    };
    AutoComplete.prototype.componentDidMount = function () {
        this.getMergeOptions(this.props.options, this.props.children);
    };
    AutoComplete.prototype.render = function () {
        var _this = this;
        var _a = this.props, options = _a.options, disabled = _a.disabled, placeholder = _a.placeholder, dropdownClassName = _a.dropdownClassName, value = _a.value, filterOption = _a.filterOption, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, onSearch = _a.onSearch, onSelect = _a.onSelect, rest = __rest(_a, ["options", "disabled", "placeholder", "dropdownClassName", "value", "filterOption", "onBlur", "onChange", "onFocus", "onSearch", "onSelect"]);
        var _b = this.state, open = _b.open, inputVal = _b.value, mergeOptions = _b.mergeOptions, inputRef = _b.inputRef;
        var contentCls = [
            'flex',
            'border',
            'rounded',
            'w-48',
            'h-8',
            'relative',
            'hover:border-brand-600',
        ];
        if (open) {
            contentCls.push('border-brand-600', 'shadow-input');
        }
        return (React.createElement(DivTag, __assign({ atomics: contentCls }, rest, { name: AutoComplete.NAME }),
            React.createElement("input", { className: addComponentPrefix('autocomplete-input') + " " + addComponentPrefix("" + (disabled
                    ? 'autocomplete-bg-gray-100 autocomplete-cursor-not-allowed'
                    : 'autocomplete-cursor-auto')), type: "text", ref: inputRef, value: inputVal, disabled: disabled, placeholder: placeholder, autoComplete: 'off', onFocus: this.onFocus, onChange: this.onChange, onBlur: this.onBlur, onClick: this.inputClick }),
            React.createElement(OptionList, { options: mergeOptions, values: this.setValues(), open: open, selectOption: function (e, option) {
                    return _this.selectOption(e, option);
                }, filterOption: filterOption, dropdownClassName: dropdownClassName })));
    };
    AutoComplete.Option = Option;
    AutoComplete.defaultProps = defaultProps;
    AutoComplete.NAME = 'autocomplete';
    AutoComplete.displayName = 'AutoComplete';
    return AutoComplete;
}(React.PureComponent));
export { AutoComplete };
